<template>
	<div class="content">
		<van-nav-bar title="导览图" left-text="返回" left-arrow @click-left="onClickLeft" />
		<img src="../assets/image/guidemap.jpg"/>
		
		
	</div>
</template>

<script>
	export default {

	}
</script>

<style scoped>
	
	img {
		margin-top: 20px;
		width: 100%;
	}
	/deep/.van-nav-bar__content{
		height: 80px;
	}
	/deep/.van-nav-bar__title{
		font-size: 30px;
		line-height: 50px;
	}
	/deep/.van-nav-bar__text{
		font-size: 30px;
	}
</style>
